import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import { ViewportProvider } from 'hooks/useViewport';
import SharedFreePageContent from 'components/SharedFreePageContent';
import WaitingScreen from 'components/WaitingScreen';
import { StateProvider } from 'hooks/useGlobalState';
import { mainReducer, mainInitialState } from 'reducers/main';
import './index.css';

// SPA entry point for "shared-free" HTML template
export default function SharedFreeApp() {
  return (
    <Router hashType="noslash">
      <ViewportProvider>
        <StateProvider initialState={mainInitialState} reducer={mainReducer}>
          <WaitingScreen />

          <SharedFreePageContent />
        </StateProvider>
      </ViewportProvider>
    </Router>
  );
}
